<template>
  <v-list-item v-if="!allRead" @click="$emit('readAllNotifications', 'read')">
    <v-list-item-title>
      {{ actions.markAllAsRead }}
    </v-list-item-title>
  </v-list-item>
  <v-list-item v-else @click="$emit('readAllNotifications', 'unread')">
    <v-list-item-title>
      {{ actions.markAllAsUnread }}
    </v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  name: "NotificationMenuList",

  props: {
    actions: {
      type: Object
    },
    allRead: {
      type: Boolean
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Management/Notifications/_Molecules/NotificationReadAllMenu.vue